<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 부가정보 : 작업환경측정결과-->
    <write-grid-container title="작업환경측정결과" v-model="form.subInfo" :options="gridContainerOptions" class="mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <fragment v-if="dataType === 'radio'">
            <PrintRadio v-for="_type in ['상반기', '하반기']" :key="`print_${_type}`" :value="form.subInfo[value] === _type" :label="_type" class="justify-center" />
          </fragment>
          <div class="print-input" v-else>{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <div v-if="dataType === 'radio'" class="radio">
            <vs-radio v-for="_type in ['상반기', '하반기']" :key="_type" v-model="form.subInfo[value]" :vs-value="_type">{{ _type }}</vs-radio>
          </div>
          <number-input v-else-if="dataType === 'number'" class="w-full" rows="5" v-model="form.subInfo[value]" :max="9999" align="left"/>
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" visible-counter />
        </div>
      </template>
    </write-grid-container>

    <!-- 파일첨부 -->
    <FileDownloadPost :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" title="파일첨부" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";

import FileDownloadPost from "@/components/FileDownloadPost.vue";
import NumberInput from "@/components/NumberInput.vue";
import PrintRadio from "@/components/print/PrintRadio.vue";

import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    WriteGridContainer,
    FileDownloadPost,
    NumberInput,
    PrintRadio,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      gridContainerOptions: {
        dataTypes: ["radio", "number", "string"],
        labels: ["구분", "대상 공정수", "측정기관"],
        values: ["구분", "대상공정", "측정기관"],
      },
      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
